var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._b({staticClass:"logout-button",attrs:{"name":"logout"},on:{"click":function($event){return _vm.logOut()}}},'v-btn',_vm.$attrs,false),[_c('span',{directives:[{name:"t",rawName:"v-t",value:('Sign out'),expression:"'Sign out'"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }